//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/dealers/views/main/lan/en';
import createEditDealer from 'Modules/dealers/views/.components/createEditDealer/lan/en';
import overview from 'Modules/dealers/views/overview/lan/en';
import dealersTab from 'Modules/dealers/views/.components/tab/lan/en';
import billingAccountsTab from 'Modules/dealers/views/.components/billingAccountsTab/lan/en';
import deleteBillingAccount from 'Modules/dealers/views/.components/deleteBillingAccount/lan/en';
import createEditBillingAccount from 'Modules/dealers/views/.components/createEditBillingAccount/lan/en';
import assignBillingAccount from 'Modules/dealers/views/.components/assignBillingAccount/lan/en';
import webHooksTab from 'Modules/dealers/views/.components/webHooksTab/lan/en';
import dealerAlertLogsTab from 'Modules/dealers/views/.components/dealerAlertLogsTab/lan/en';
import createEditWebHook from 'Modules/dealers/views/.components/createEditWebHook/lan/en';
import deleteWebHook from 'Modules/dealers/views/.components/deleteWebHook/lan/en';
import resendDealerAlertLog from 'Modules/dealers/views/.components/resendDealerAlertLog/lan/en';


locales = {
    ...locales,
    ...main,
    ...createEditDealer,
    ...overview,
    ...dealersTab,
    ...billingAccountsTab,
    ...deleteBillingAccount,
    ...createEditBillingAccount,
    ...assignBillingAccount,
    ...webHooksTab,
    ...dealerAlertLogsTab,
    ...createEditWebHook,
    ...deleteWebHook,
    ...resendDealerAlertLog
};


export default locales;